import { render, staticRenderFns } from "./FaultsList.vue?vue&type=template&id=280a3534&"
import script from "./FaultsList.vue?vue&type=script&lang=js&"
export * from "./FaultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports